import { EMPTY, Observable, of, switchMap, take, zip } from 'rxjs';
import { inject, Injectable } from '@angular/core';
import { AclService } from '@/core/services/security/acl.service';
import { SecurityService } from '@/core/services/security/security.service';

@Injectable()
export class BootstrapService {
    private security = inject(SecurityService);
    private aclService = inject(AclService);

    public executePreAuth(): Observable<any> {
        return of({});
    }

    public executeAuth(): Observable<any> {
        return this.security.isAuthenticated().pipe(
            switchMap((value) => {
                if (!value) {
                    return this.security.login('/').pipe(switchMap(() => EMPTY));
                }
                return of({});
            }),
            take(1)
        );
    }

    public executePostAuth(): Observable<any> {
        return zip(this.aclService.load(), this.security.loadAuthorizedUserInfo());
    }
}
